<!-- BANNER SECTION START -->
<div class="home-banner-section">
    <div class="home-slider-item">
      <div class="slider-item">
        <div class="container">
          <div class="slider-item-info">
            <div class="slider-item-img-wrap">
              <img src="assets/img/landing-pages/FedRAMP.png" alt="FedRAMP Banner">
            </div>
            <div class="slider-item-details-wrap">
              <h1>RegScale Accelerates FedRAMP ATO Process</h1>
              <p> Partner with RegScale to streamline compliance</p>
              <a class="btn-link" href="https://go.regscale.com/RegScale-Create-Account"> Options for getting started →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- BANNER SECTION END -->

  <!-- ABOUT SECTION START -->
  <div class="about-section">
    <div class="container">
      <div class="about-section-inner">
        <div class="relationships-left-block about-col6">
          <div class="heading">
            <h2>The FedRAMP Program</h2>
          </div>
          <div class="about-para-box">
              <p>The Federal Risk and Authorization Management Program (FedRAMP) is a government-wide program that provides a standardized approach to security assessment, authorization, and continuous monitoring for cloud products and services. FedRAMP empowers agencies to use modern cloud technologies, with emphasis on security and protection of federal information, and helps accelerate the adoption of secure, cloud solutions.</p>
              <p>The FedRAMP PMO resides within GSA and supports agencies and cloud service providers through the FedRAMP authorization process and maintains a secure repository of FedRAMP authorizations to enable reuse of security packages.</p>
          </div>
        </div>
        <div class="relationships-right-block about-col6">
          <div class="heading">
            <h2>RegScale, In a Nutshell</h2>
          </div>
          <div class="about-para-box">
              <p>RegScale brings compliance into the modern era through digitization and automation in order to increase scalability while lowering risk, cost, time, and labor. The platform helps organizations move from a manual compliance process to an API-centric, automated approach while keeping compliance documentation continuously up to date. The collaborative capabilities of the platform allow all stakeholders and data owners in the compliance process to work together across platforms to fulfill reporting requirements more quickly and accurately.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ABOUT SECTION END -->

  <!-- ATO PROGRES SECTION START -->
  <div class="ato-progres-section">
    <div class="container">
      <div class="heading">
        <h3>How Does RegScale Accelerate the FedRAMP ATO Process?</h3>
        <p>RegScale provides technology and an ecosystem of integrations and service providers to streamline compliance and audit readiness including the requirements for security assessments, authorizations, and continuous monitoring for cloud products and services.</p>
      </div>
      <div class="ato-progres-wrap full-ato-progres-item">
        <div class="ato-progres-item ">
          <div class="ato-progres-info">
            <div class="ato-progres-img-wrap">
                <img src="assets/img/team/karmel.jpg" alt="Anil Karmel" />
            </div>
            <div class="ato-progres-info-wrap">
              <p> <em> “As digital transformation accelerates, regulatory compliance requirements have necessarily expanded to keep up. But technology and compliance have evolved faster than the processes and tools to effectively meet the new standards. RegScale allows companies to modernize and pivot from static compliance documentation and processes to a digital and automated solution.”</em></p>
              <p> <strong>- Anil Karmel, co-founder and CEO, RegScale. </strong> </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ATO PROGRES SECTION END -->

  <!-- WHERE GO FROM HERE SECTION START -->
  <div class="where-go-section">
    <div class="container">
      <div class="where-go-wrap">
        <div class="heading">
          <h4>Where do we go from here?</h4>
        </div>
        <a href="https://go.regscale.com/RegScale-Create-Account" title="Options for getting started" class="btn-red">Options for getting started →</a>
      </div>
    </div>
  </div>
  <!-- WHERE GO FROM HERE SECTION END -->

  <!-- WORK SECTION START -->
  <div class="work-section mb-5">
    <div class="container">
      <div class="heading">
        <h5>Want to become a partner?</h5>
        <p>
            Join our ecosystem of partners to make the world a safer place through compliance.
            No<br>contribution is too small and together, we can all make a difference and reimagine a better<br/>
            world where compliance is cheaper, easier, and more effective
        </p>
          <a [routerLink]="['/partnership']" title="Options for getting started" class="btn-gray">Options for getting started →</a>

      </div>
    </div>
  </div>
  <!-- WORK SECTION END -->
